<template>
  <div class="form-list">
    <el-form
      class="form form-extra-large"
      ref="form"
      :rules="rules"
      :model="reservation"
      label-position="right"
      label-width="130px"
    >
      <el-form-item label="课程门店">
        <span class="title">{{course.store_name}}</span>
      </el-form-item>

      <el-form-item label="课程名称">
        <span class="title">{{course.course_name}}</span>
      </el-form-item>

      <el-form-item label="课程老师">
        <div class="flex">
          <template v-for="(v, i) in course.teachers">
            <v-avatar-nickname
              :key="'t' + i"
              :value="v.avatar"
              :nickname="v.nickname"
              class="avatar-item"
              width=""
            />
            <template v-if="v.sub_teacher_id">
              <i :key="'arrow' + i" class="icon-arrow-right avatar-item" />
              <v-avatar-nickname
                :key="'sub' + i"
                :value="v.sub_avatar"
                :nickname="v.sub_nickname"
                class="avatar-item"
                width=""
              />
            </template>
          </template>
        </div>
      </el-form-item>

      <el-form-item label="课程时间">
        <span class="title">{{ course.date }} {{ course.start_time }} ~ {{ course.end_time }}</span>
      </el-form-item>

      <template v-if="isFreeCourse">
        <el-form-item label="预约方式">
          <span v-if="course.is_show_free" class="title">
            <el-tag type="warning" size="small" class="reserve-mode-tag">不鸽费预约</el-tag>
            <template v-if="course.price">押金 <b class="primary-color">{{ course.price | toYuan }}</b> 元，学员签到后由后台发起退款</template>
            <span v-else class="info-color">未设置押金金额</span>
          </span>
          <span v-else class="title">
            <el-tag type="success" size="small" class="reserve-mode-tag">免费预约</el-tag>
            不扣课卡、不收费
          </span>
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="扣卡次数">
          <span class="title">
            <span class="primary-color count-number">{{ course.decrement_number }}</span> 次
          </span>
        </el-form-item>

        <el-form-item label="通卡扣卡天数">
          <span class="title">
            <span class="primary-color count-number">{{ course.decrement_days }}</span> 天
          </span>
        </el-form-item>
      </template>

      <el-form-item label="预约统计">
        <v-page-reservation-list :value="course"/>
      </el-form-item>

      <el-form-item label="签到学员" prop="student_id">
        <v-select-student class="student-select" v-model="reservation.student_id" @change="handleStudentChange"/>
      </el-form-item>

      <el-form-item v-if="isFreeCourse" label="消费方式">
        <span class="title"><span class="success-color">免费预约</span>：不扣课卡与课次券，选择学员后直接签到</span>
      </el-form-item>

      <el-form-item v-if="!isFreeCourse" label="消费方式">
        <el-radio v-model="isCardTicket" :label="0">课卡</el-radio>
        <el-radio v-model="isCardTicket" :label="1">课次券</el-radio>
      </el-form-item>

      <el-form-item v-if="!isFreeCourse && isCardTicket" label="消费课次券">
        <v-select-card-ticket-list
          class="student-select"
          v-model="reservation.card_ticket_id"
          :student-id="reservation.student_id"
          @listLengthChange="handleListLengthChange"
          @change="handleCardChange"
        />
        <el-alert
          v-if="!listLength && reservation.student_id"
          title="学员名下暂无可使用的课次券，无法进行签到"
          type="error"
          show-icon
          :closable="false"
        />
      </el-form-item>
      <el-form-item v-else-if="!isFreeCourse" label="消费课卡">
        <v-select-card-list
          class="student-select"
          v-model="reservation.card_id"
          :student-id="reservation.student_id"
          :card-state="cardStates.usable.value"
          :course-column-id="course.course_column_id"
          @listLengthChange="handleListLengthChange"
          @change="handleCardChange"
        />
        <el-alert
          v-if="!listLength && reservation.student_id"
          title="学员名下暂无可使用的课卡，无法进行签到"
          type="error"
          show-icon
          :closable="false"
        />
      </el-form-item>

      <div v-if="!isFreeCourse" class="card-info-box" :style="isMobile ? '' : `height: ${listLength * 282}px;min-height: ${isCardTicket ? 310 : 435}px`">
        <template v-if="reservation.card_id || reservation.card_ticket_id">
          <el-form-item v-if="!isCardTicket" label="课卡类型">
            <span class="title">{{ card.card_type_name }}</span>
          </el-form-item>

          <el-form-item :label="isCardTicket ? '归属门店' : '办理门店'">
            <span class="title" :class="{ 'info-color': isCardTicket && !card.store_id }">{{ card.store_name }}</span>
            <span v-if="isCardTicket && card.is_app && !card.store_id" class="primary-color">签到/爽约后自动归属到当前门店</span>
            <span v-else-if="isCardTicket && card.store_source_name" class="info-color">（{{ card.store_source_name }}）</span>
          </el-form-item>

          <el-form-item label="有效次数" v-if="isCardTicket || card.is_number_limit">
            <span class="title"><span class="success-color">{{ card.expire_number | toYuan }}</span> 次</span>
          </el-form-item>

          <el-form-item label="有效天数">
            <span v-if="isCardTicket" class="title"><span class="success-color">{{ card.expire_days | toYuan }}</span> 天</span>
            <span v-else class="title"><span class="success-color">{{ card.expire_days }}</span> 天</span>
          </el-form-item>

          <el-form-item label="失效时间">
            <span v-if="card.expire_time" class="title">{{ card.expire_time | timeToYmd }}</span>
            <span v-else class="title"><span class="primary-color">未开{{ reservation.card_id ? '卡' : '券' }}</span></span>
          </el-form-item>

          <template v-if="!isCardTicket">
            <el-form-item label="适用门店">
          <span class="title">
            <template v-if="card.store_names">仅限 <span class="success-color">{{ card.store_names }}</span> 店使用</template><span v-else class="success-color">全国通用</span>
          </span>
            </el-form-item>

            <template v-if="card.store_names">
              <el-form-item label="适用门店限制天数">
                <span class="title">{{ card.store_limit_expire_days }} 天</span>
              </el-form-item>

              <el-form-item label="适用门店失效日期">
            <span v-if="card.expire_time" class="title">
              {{ card.store_limit_expire_time | timeToYmd }}（到期后课卡将恢复为全国通用）
            </span>
                <span v-else class="title">未开卡</span>
              </el-form-item>
            </template>
          </template>

          <el-form-item v-if="isCardTicket || card.is_number_limit" label="消费次数" prop="decrement_number">
            <v-input-money
              class="decrement-input"
              :min="course.decrement_number"
              :max="999"
              v-model="reservation.decrement_number"
              :is-show-suffix="true"
              suffix-name="次"
            />
          </el-form-item>
          <el-form-item v-else label="消费天数" prop="decrement_days">
            <v-input-money
              class="decrement-input"
              :min="course.decrement_days"
              :max="366"
              v-model="reservation.decrement_days"
              :is-show-suffix="true"
              suffix-name="天"
            />
          </el-form-item>
        </template>
      </div>

      <el-form-item>
        <el-button type="primary" @click="handleSubmit" :loading="isSaving" :disabled="!isFreeCourse && !listLength">一键预约并签到</el-button>
        <el-button @click="courseListBack">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import RouteConfig from '@/router/config';
import { show } from '@/api/course';
import { store } from '@/api/course-reservation';
import { toCent, toYuan } from "@/utils/number";
import cardStates from "@/enums/cardStates";
import {mapGetters} from "vuex";

export default {
  name: RouteConfig.courseReserve.name,
  data: () => ({
    courseListBack: RouteConfig.courseList.back,
    isSaving: false,
    isCardTicket: 0,
    listLength: false,
    cardStates,
    course: {
      date: '',
      start_time: '',
      end_time: '',
      student_number: '',
      student_count: '',
      signed_count: '',
      trial_count: '',
      wait_count: '',
      course_name: '',
      decrement_number: 0,
      decrement_days: 0,
      // 预约方式：这两个字段必须在初始对象里占位，否则 show() 的 Object.keys 回填会把它们过滤掉
      is_show_free: 0,
      price: 0,
      store_name: '',
      course_column_id: 0,
      teachers: [],
      students: [],
    },
    card: {
      id: 0,
      store_name: '',
      card_number: '',
      is_generic: 0,
      card_type_name: '',
      card_name: '',
      is_number_limit: 0,
      is_disable_column: 0,
      expire_number: '',
      expire_days: '',
      expire_time: '',
      single_store_expire_days: '',
      single_store_expire_time: '',
    },
    reservation: {
      course_id: 0,
      student_id: '',
      card_id: '',
      card_ticket_id: '',
      decrement_number: 1,
      decrement_days: 0,
    },
    rules: {
      student_id: [{ required: true, message: '请选择所属学员', trigger: 'change' }],
      decrement_number: [{ required: true, message: '请选择输入打卡所扣次数', trigger: 'change' }],
    },
  }),
  watch: {
    isCardTicket(value) {
      value ? this.reservation.card_id = 0 : this.reservation.card_ticket_id = 0;
    }
  },
  computed: {
    ...mapGetters([
      'isMobile',
    ]),
    id() {
      return +this.$route.params.id || 0;
    },
    // 免费预约课程（扣卡次数为 0）不扣课卡与课次券，签到不要求选卡
    isFreeCourse() {
      return !this.course.decrement_number;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleListLengthChange(listLength) {
      this.listLength = listLength;
    },
    handleCardChange(card) {
      this.card = card;
    },
    handleStudentChange() {
      this.reservation.card_id = '';
      this.reservation.card_ticket_id = '';
      this.listLength = false;
      this.card = {
        id: 0,
        store_name: '',
        card_number: '',
        is_generic: 0,
        card_type_name: '',
        card_name: '',
        is_number_limit: 0,
        is_disable_column: 0,
        expire_number: '',
        expire_days: '',
        expire_time: '',
        single_store_expire_days: '',
        single_store_expire_time: '',
      };
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      if (data.decrement_number) {
        data.decrement_number = toYuan(data.decrement_number);
        this.reservation.decrement_number = data.decrement_number;
      }
      if (data.decrement_days) {
        data.decrement_days = toYuan(data.decrement_days);
        this.reservation.decrement_days = data.decrement_days;
      }
      // 免费课：扣次扣天按 0 处理（表单默认值是 1，不能带上去）
      if (!data.decrement_number) {
        this.reservation.decrement_number = 0;
        this.reservation.decrement_days = 0;
      }

      const { course } = this;
      Object.keys(data).forEach(key => {
        if (key in course) course[key] = data[key];
      });
    },
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const { ...postData } = this.reservation;
        postData.course_id = this.id;
        if (this.isFreeCourse) {
          // 免费课不挂卡、不扣次：卡与券一律置 0，后端按免费路径直接签到
          postData.card_id = 0;
          postData.card_ticket_id = 0;
          postData.decrement_number = 0;
          postData.decrement_days = 0;
        } else {
          postData.decrement_number = toCent(postData.decrement_number);
          postData.decrement_days = toCent(postData.decrement_days);
        }

        this.isSaving = true;
        const { isError } = await store(postData);
        this.isSaving = false;
        if (isError) return;

        this.$message({
          message: '打卡成功！',
          type: 'success',
          duration: 3000,
        });
        Object.assign(this, {
          card: {
            id: 0,
            store_name: '',
            card_number: '',
            is_generic: 0,
            card_type_name: '',
            card_name: '',
            is_number_limit: 0,
            is_disable_column: 0,
            expire_number: '',
            expire_days: '',
            expire_time: '',
            single_store_expire_days: '',
            single_store_expire_time: '',
          },
          reservation: {
            course_id: 0,
            student_id: '',
            card_id: '',
            decrement_number: this.reservation.decrement_number,
            decrement_days: this.reservation.decrement_days,
          },
        });
        this.show();
      });
    },
  },
};
</script>

<style src="./reserve.css" scoped/>
